<template>
  <div class="page">
    <el-form size="small" label-width="100px" class="margin15-tb">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="线路JSON" >
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入JSON"
              v-model="transferJson">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8" :offset="4">
          <el-button type="primary" size="small" @click="submitCompany">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  props: {
    changeTabe: {
      type: String
    },
    companyIdTemp: {
    }
  },
  data() {
    return {
      companyId: null,
      transferJson: null
    };
  },
  watch: {
    changeTabe(type) {
      if (type === '转人工通道配置') {
        if (this.companyId !== '') {
          this.getCompanyInfo(this.companyId);
        }
      }
    },
    companyIdTemp(companyId) {
      this.companyId = companyId;
      if (this.changeTabe === '转人工通道配置') {
        this.getCompanyInfo(companyId);
      }
    }
  },
  methods: {
    getCompanyInfo(companyId) {
      this.$ajax({
        url: '/company/getCompanyByPrimaryKey',
        params: { companyId },
        method: 'GET'
      }).then((res) => {
        console.warn(res);
        this.transferJson = res.data.transferJson;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    submitCompany() {
      this.$ajax({
        prompt: true,
        url: '/company/updateTransfer',
        data: {
          companyId: this.companyId,
          transferJson: this.transferJson
        }
      }).then((res) => {
        console.warn(res);
        this.getCompanyInfo(this.companyId);
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/company/transfer_labor.vue